import { EditorState, Modifier, RichUtils } from 'draft-js';
import { useCallback } from 'react';
import { Entities } from '../types';
import { addLink, highlightToggle } from '../util/inline';
import { StyleType } from '../util/style';

var useHandleInlineStyleToggleCallback = function useHandleInlineStyleToggleCallback(setEditorState) {
  return useCallback(function (inlineStyle) {
    return function (event) {
      event.preventDefault();
      setEditorState(function (editorState) {
        return RichUtils.toggleInlineStyle(editorState, inlineStyle);
      });
    };
  }, [setEditorState]);
};

var useResetStyleToggleCallback = function useResetStyleToggleCallback(setEditorState) {
  return useCallback(function () {
    return function (event) {
      event.preventDefault();
      setEditorState(function (editorState) {
        var contentState = editorState.getCurrentContent();
        var styles = Object.values(StyleType);
        var contentWithoutStyles = styles.reduce(function (newContentState, style) {
          return Modifier.removeInlineStyle(newContentState, editorState.getSelection(), style);
        }, contentState);
        return EditorState.push(editorState, contentWithoutStyles, 'change-inline-style');
      });
    };
  }, [setEditorState]);
};

var useAddExternalLinkCallback = function useAddExternalLinkCallback(setEditorState) {
  return useCallback(function (data) {
    setEditorState(function (editorState) {
      return addLink(editorState, {
        type: Entities.ExternalLink,
        data: data
      });
    });
  }, [setEditorState]);
};

var useAddInternalLinkCallback = function useAddInternalLinkCallback(setEditorState) {
  return useCallback(function (data) {
    setEditorState(function (editorState) {
      return addLink(editorState, {
        type: Entities.InternalLink,
        data: data
      });
    });
  }, [setEditorState]);
};

var useAddAffiliationLinkCallback = function useAddAffiliationLinkCallback(setEditorState) {
  return useCallback(function (data) {
    setEditorState(function (editorState) {
      return addLink(editorState, {
        type: Entities.AffiliationLink,
        data: data
      });
    });
  }, [setEditorState]);
};

var useHighlightToggleCallback = function useHighlightToggleCallback(setEditorState) {
  return useCallback(function () {
    return function (event) {
      event.preventDefault();
      setEditorState(function (editorState) {
        return highlightToggle(editorState);
      });
    };
  }, [setEditorState]);
};

export { useHandleInlineStyleToggleCallback, useHighlightToggleCallback, useResetStyleToggleCallback, useAddExternalLinkCallback, useAddInternalLinkCallback, useAddAffiliationLinkCallback };